<script setup>
import { useOrgStore } from '@/stores/org'
import { useGeoStore } from '@/stores/geo'
import {useRoute, useRouter} from "vue-router"
import {ref} from 'vue'
import {File} from 'lucide-vue-next'
import {Button} from '@/components/ui/button'

const orgStore = useOrgStore()

const geoStore = useGeoStore()
const router = useRouter()
const route = useRoute()
const fileUploadInput = ref(null)

const emit = defineEmits(['change'])

const setFiles = (e) => {
  if (route.name !== 'FileViewer') {
    const orgId = route.params.org_id || orgStore.selectedOrg
    router.push({name: 'FileViewer', params: {org_id: orgId}})
  }

  geoStore.setFiles(e.target.files)
  emit('change', e.target.files)
}

const resetFiles = () => {
  fileUploadInput.value.value = ''
  geoStore.setFiles(null)
}
</script>

<template>
  <div>
    <input
      ref="fileUploadInput"
      type="file"
      accept=".shp, .kml, .kmz, .geojson, .jpg, .jpeg, .png, '.heic', '.heif', '.avif', '.webp'"
      @change="setFiles($event)"
      @click="resetFiles()"
      style="visibility: hidden; position: absolute; top: 0; left: 0; pointer-events: none;"
    />

    <Button
      variant="ghost"
      type="button"
      id="draw-file-button"
      class="w-full justify-start gap-2.5 h-auto px-2 py-1.5 font-normal text-sm"
      aria-label="Upload a file"
      title="Upload a file"
      @click="$refs.fileUploadInput.click()"
    >
      <span class="w-6 h-6 rounded-full bg-primary flex items-center justify-center shrink-0">
        <File class="w-3.5 h-3.5 text-white" aria-hidden="true" />
      </span>
      <span class="truncate">File</span>
    </Button>
  </div>
</template>
